<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 16.1996L4.8 11.9996L3.4 13.3996L9 18.9996L21 6.99961L19.6 5.59961L9 16.1996Z" fill="#008489"/>
</svg>
